
// eslint-disable-next-line
import { ScheduleModel } from "@/domain/models";
import { professionalService, scheduleService } from "@/domain/services";
import { defineComponent } from "vue";
import { Form, SelectOption } from "../util";

import { mapState, mapActions } from "vuex";
import { WeekDay } from "@/common/constants";
import { OptionSelect } from "@/presentation/models";

type ComponentData = {
  professional_options: OptionSelect[];
  professional_id?: number;
  WeekDay: string[];
};

export default defineComponent({
  name: "ScheduleList",
  data(): ComponentData {
    return {
      WeekDay,
      professional_options: [],
      professional_id: undefined,
    };
  },
  computed: {
    ...mapState("schedules", ["schedules", "isLoading"]),
    ...mapState("auth", ["current_user"]),
  },
  components: {
    Form,
    SelectOption,
  },
  created() {
    this.loadProfesssionalsOptions();
  },
  methods: {
    loadProfesssionalsOptions() {
      professionalService.load().then((professionals) => {
        this.professional_options = professionals.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        this.professional_id = !this.current_user.admin
          ? this.current_user.id
          : (this.professional_options?.[0].value as number);
      });
    },
    deleteSchedule(id: number) {
      if (confirm("Você realmente deseja deletar esse horário?")) {
        scheduleService.deleteById(id).then(() => {
          this.loadSchedules(this.professional_id);
        });
      }
    },
    ...mapActions({ loadSchedules: "schedules/load" }),
  },
  watch: {
    professional_id(id) {
      this.loadSchedules(id);
    },
  },
});
